export const LIMIT = 20;

export const FIRMWARE_STATUS = {
  latest: {
    label: 'Актуальная',
    className: 'bg-green-50 text-green-700',
  },
  outdated: {
    label: 'Устарела',
    className: 'bg-orange-100 text-orange-800',
  },
  unknown: {
    label: 'Неизвестно',
    className: 'bg-gray-100 text-gray-600',
  },
};

export const FIRMWARE_STATUS_OPTIONS = [
  { value: 'latest', label: 'Актуальная' },
  { value: 'outdated', label: 'Устаревшая' },
  { value: 'unknown', label: 'Неизвестно' },
];

export const SUMMARY_CARDS = [
  { status: '', field: 'total', label: 'Всего' },
  { status: 'latest', field: 'latest', label: 'Актуальные' },
  { status: 'outdated', field: 'outdated', label: 'Устаревшие' },
  { status: 'unknown', field: 'unknown', label: 'Неизвестно' },
];

export const FIRMWARE_FILE_FIELDS = [
  { key: 'version', label: 'Версия', emphasize: true },
  { key: 'channel', label: 'Канал' },
  { key: 'file_name', label: 'Файл', className: 'break-all' },
  { key: 'size', label: 'Размер' },
  { key: 'modified_at', label: 'Изменён' },
];

export const RESOURCE_LABELS = {
  cold_water: 'Холодная вода',
  hot_water: 'Горячая вода',
  cold: 'Холодная вода',
  hot: 'Горячая вода',
  water: 'Вода',
  electricity: 'Электричество',
  heat: 'Тепло',
  heating: 'Тепло',
  gas: 'Газ',
};
